import { render, staticRenderFns } from "./HeroHomeSlider.vue?vue&type=template&id=6626f158&"
import script from "./HeroHomeSlider.vue?vue&type=script&lang=js&"
export * from "./HeroHomeSlider.vue?vue&type=script&lang=js&"
import style0 from "./HeroHomeSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VideoStrapi: require('/home/northbankcm/public_html/frontend/components/modules/VideoStrapi.vue').default,ResponsiveImageStrapi: require('/home/northbankcm/public_html/frontend/components/modules/ResponsiveImageStrapi.vue').default})
